module.exports = __webpack_public_path__ + "img/chess-8348280_1280_thumb.311c42eb.jpg";